export default "__VITE_ASSET__Ctlhnslx__"